// User Types used to identify the user

export const WEBINAR_DETAILS = 'WebinarDetails';
export const DASHBOARD = 'Dashboard';
